<template>
  <div>
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>

      <el-breadcrumb-item :to="{ path: '/my' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my?active=我的报名' }">我的报名</el-breadcrumb-item>
      <el-breadcrumb-item class="">考试缴费</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <h2>支付成功</h2>
      <button @click="back">返回</button>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
export default {
  props: {},
  data() {
    return {
      url: ""
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query = this.$route.query;
    if (query.post_id){
      this.url = "/Step?post_id="+query.post_id;
    }else{
      this.url = "/my?active=我的报名";
    }

  },
  watch: {},
  methods: {
    back() {
      this.$router.push(this.url);
    },
  },
  components: {
    Head,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.content {
  h2 {
    font-size: 0.5rem;
    color: #00a0e9;
    text-align: center;
    padding: 0.6rem 0;
  }
  button {
    width: 2.35rem;
    height: 0.93rem;
    background-color: red;
    border-radius: 0.1rem;
    font-size: 0.46rem;
    color: #fff;
    margin: 1rem 0;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
</style>

